import { config, executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, getHeaders } from './config'

const responseParser = (response: any) => {
  console.log('logout', { response })
  return isSuccessResponse(response)
}

const logoutCall = () => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.logout),
    method: 'POST',
    config: config.default,
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { logoutCall }
